import cx from 'classnames'
import PropTypes from 'prop-types'

const BASE_CLASS = 'mt-CardAd-footer'

const CardAdFooter = ({children, visible, hasSmallPadding, hasLeftItem, isGridLayout}) => {
  const className = cx(BASE_CLASS, {
    [`${BASE_CLASS}--smallPadding`]: hasSmallPadding,
    [`${BASE_CLASS}--hasLeftItem`]: hasLeftItem,
    [`${BASE_CLASS}--grid`]: isGridLayout
  })

  if (!visible) return null

  return <div className={className}>{children}</div>
}

CardAdFooter.displayName = 'CardAdFooter'

CardAdFooter.propTypes = {
  children: PropTypes.node,
  visible: PropTypes.bool,
  hasSmallPadding: PropTypes.bool,
  hasLeftItem: PropTypes.bool,
  isGridLayout: PropTypes.bool
}

export default CardAdFooter
